import { cn } from '@/lib/utils';
import { FC, PropsWithChildren } from 'react';

export const HighlightText: FC<
  PropsWithChildren<{ searchTerm: string; as?: React.ElementType; markClassName?: string }>
> = ({ children, searchTerm, as: Component = 'span', markClassName }) => {
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  const text = typeof children === 'string' ? children : String(children || '');
  if (!searchTerm || !text) return <Component>{children}</Component>;

  const matchIndex = text.toLowerCase().indexOf(searchTerm.toLowerCase());

  if (matchIndex === -1) return <Component>{children}</Component>;

  const beforeMatch = text.slice(0, matchIndex);
  const match = text.slice(matchIndex, matchIndex + searchTerm.length);
  const afterMatch = text.slice(matchIndex + searchTerm.length);

  return (
    <Component>
      {beforeMatch}
      <mark className={cn('bg-orange-300', markClassName)}>{match}</mark>
      {afterMatch}
    </Component>
  );
};
